import { UiKit } from '@datavant/uikit';
import React from 'react';

export const ColoredBox = (props: {
    color?: string;
    borderColor?: string;
    title?: string;
    icon?: JSX.Element;
    children?: React.ReactNode;
}): JSX.Element => {
    const style = {
        padding: UiKit.consistency.buffer,
        alignItems: 'stretch',
        width: '100%',
        border: `1px solid ${props.borderColor}`,
        backgroundColor: props.color,
        borderRadius: UiKit.consistency.borderRadius,
        boxShadow: '0px 0px 1px rgba(17, 47, 78, 0.24)',
    };

    return (
        <UiKit.Chakra.VStack style={style} justify={'flex-start'}>
            <UiKit.Chakra.HStack
                justify={'flex-start'}
                align={'flex-start'}
                width={'100%'}
                spacing={UiKit.consistency.halfBuffer}
            >
                <UiKit.Chakra.HStack w={UiKit.consistency.halfBuffer} align={'center'} justify={'center'}>
                    {props.icon}
                </UiKit.Chakra.HStack>
                {props.title ? <UiKit.Text.Heading5 text={props.title} /> : props.children}
            </UiKit.Chakra.HStack>
            <UiKit.Chakra.VStack padding={`0 ${UiKit.consistency.buffer}`} align="flex-start">
                {props.title && props.children}
            </UiKit.Chakra.VStack>
        </UiKit.Chakra.VStack>
    );
};
